import { resolveCostPerUnitSurface, resolveOverallBudget } from "../lib/project";
import { ProjectGeneratedEntity } from "./generated/ProjectGeneratedEntity";
import BitSet from "bitset";

export abstract class ProjectEntity extends ProjectGeneratedEntity {
    public get estimatedOverallBudget(): number | null {
        return resolveOverallBudget(this.estimatedDemolitionBudget, this.estimatedConstructionBudget);
    }

    public get realOverallBudget(): number | null {
        return resolveOverallBudget(this.realDemolitionBudget, this.realConstructionBudget);
    }

    public get estimatedCostSurface(): number | null {
        const overallBudget = resolveOverallBudget(this.estimatedDemolitionBudget, this.estimatedConstructionBudget);
        return resolveCostPerUnitSurface(overallBudget, this.floorSurface);
    }

    public get realCostSurface(): number | null {
        const overallBudget = resolveOverallBudget(this.realDemolitionBudget, this.realConstructionBudget);
        return resolveCostPerUnitSurface(overallBudget, this.floorSurface);
    }

    public get isBugWorkflowEnabled(): boolean {
        return this.bugWorkflow != null;
    }

    public get settingWeekdays(): number[] {
        if (this.settingWeekdaysData === null || this.settingWeekdaysData === undefined) {
            return [];
        }
        const bs = new BitSet(this.settingWeekdaysData);
        const weekdays: number[] = [];
        for (let i = 0; i < 7; i++) {
            if (bs.get(i)) {
                weekdays.push(i);
            }
        }
        return weekdays;
    }

    public set settingWeekdays(weekdays: number[]) {
        const bs = new BitSet();
        weekdays.forEach((day) => bs.set(day));
        this.settingWeekdaysData = parseInt(bs.toString(), 2);
    }
}
